export default "__VITE_ASSET__$k3hhY24__"